import { FieldArray } from 'react-final-form-arrays';
import PropTypes from 'prop-types';
import { Field, withForm } from './finalForm';
import Prompt from '../components/Prompt';
import LinkContainer from '../components/LinkContainer';
import normalizePhone from './normalize';
import renderField from './render/renderField';
import renderFileField from './render/renderFileField';
import validateVacancyForm from './validate/validateVacancyForm';
import * as resumeFields from './constants/resumeFormFieldConstants';

import {
  email,
  matchPattern,
  maxLength,
  phone,
  required,
  resume,
} from './validators';
import renderSelectField from './render/renderSelectField';
import '../styles/layout/ResumeForm.css';
import ErrorMessage from '../components/ErrorMessage';
import RenderEducationFieldSet from './render/renderEducationFieldSet';
import RenderSkillKeys from './render/renderSkillKeys';
import RenderLanguage from './render/renderLanguage';


const maxLength10000 = maxLength(10000);
const maxLength200 = maxLength(200);
const matchPatternNumber = matchPattern(/^[ 0-9]+$/, 'Можно вводить только числа');


const EditResumeForm = (props) => {
  const validateResumeForm = (fieldType) => {
    switch (fieldType) {
      case 'tel': return phone;
      case 'email': return email;
      case 'textarea': return maxLength10000;
      case 'file': return resume;
      case 'number': return matchPatternNumber;
      default: return maxLength200;
    }
  };

  const getRenderType = (type) => {
    switch (type) {
      case 'file': return renderFileField;
      case 'select': return renderSelectField;
      default: return renderField;
    }
  };

  // `section` replaces redux-form <FormSection>: field names are prefixed.
  const getFields = (fields, section) => (
    fields.map((field) => {
      const { type } = field;
      return (
        <Field
          key={field.name}
          type={field.type}
          name={`${section}.${field.type === 'file' ? `userFile_${field.name}` : field.name}`}
          component={getRenderType(type)}
          label={field.type !== 'file' ? field.placeholder
            : `Прикрепить ${field.placeholder && field.placeholder.toLowerCase()}`}
          validate={field.required ? [validateResumeForm(field.type), required]
            : validateResumeForm(field.type)}
          rows="10"
          normalize={field.name === 'phone' ? normalizePhone : undefined}
          accept={field.type === 'file' ? '.jpeg, .jpg, .webp' : undefined}
          info={field.type === 'file' ? 'Допустимы файлы в формате .jpeg, .jpg, .webp, размером не более 10 МБ.'
            : undefined}
          options={field.options && field.options}
        />
      );
    })
  );

  const {
    submitFailed,
    handleSubmit,
    submitSucceeded,
    dirty,
    submitting,
  } = props;

  return (
    <form className="resume-form" onSubmit={handleSubmit}>
      <Prompt message="Вы действительно хотет закрыть форму" when={dirty && !submitSucceeded} />

      <div className="resume-form__field border-bottom pb-3">
        <h3 className="title customization-container__title">Персональная информация</h3>
        {getFields(resumeFields.personalFields, 'personal')}
      </div>

      <div className="resume-form__field border-bottom pt-4 pb-3">
        <h3 className="title customization-container__title">Желаемая должность и заплата</h3>
        {getFields(resumeFields.positionAndSalaryFields, 'workInfo')}
      </div>

      <div className="resume-form__field border-bottom pt-4 pb-4">
        <h3 className="title customization-container__title">Образование</h3>
        {getFields([resumeFields.educationFields.grade], 'education')}
        <FieldArray
          component={RenderEducationFieldSet}
          validateResume={validateResumeForm}
          name="education.establishments"
        />
      </div>

      <div className="resume-form__field border-bottom pt-4 pb-4">
        <h3 className="title customization-container__title">Ключевые навыки</h3>
        <FieldArray
          component={RenderSkillKeys}
          name="keySkills"
          className="mb-3"
        />
        <FieldArray
          component={RenderLanguage}
          name="languages"
        />
      </div>

      <div className="resume-form__field pt-3">
        <h3 className="title customization-container__title">Обо мне</h3>
        <Field
          component={renderField}
          className="resume-form-textarea"
          type="textarea"
          name="about"
        />
      </div>

      <div className="buttons-container pt-2">
        <button
          className="button"
          type="submit"
          disabled={submitting}
        >
          Сохранить
        </button>
        <LinkContainer
          to="/resume/"
        >
          <button type="button" className="button button_color_dark-blue">Отмена</button>
        </LinkContainer>
      </div>
      {submitFailed && <div className="form-error">Не все поля заполнены корректно</div>}
      <ErrorMessage errorName="createVacancyError" />
    </form>
  );
};

EditResumeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
};

export default withForm({
  form: 'editResume',
  validate: validateVacancyForm,
  resetSubmitFailedOnChange: true,
})(EditResumeForm);
